/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef} from 'react';
import PageWrapper from '../../../../modules/PageWrapper';
import {observer} from 'mobx-react';
import {useStore} from '../../../../../store/store';
import {Link} from 'react-router-dom';
import {Button} from '../../../../shared/Buttons';
import Filters from '../../../../table/new/filters/Filters';
import Presets from '../../../../table/new/Presets';
import {getFilters} from './getFilters';
import {facebookStatisticsFilters} from './filtersConfigs';
import {facebookStatisticsGroups} from './groupsConfigs';
import TableWrapper from '../../../../table/new/TableWrapper';
import Columns from '../../../../table/new/Columns';
import {baseFields} from '../../../../table/new/customizationTable';
import BlankSheet from '../../../../table/new/BlankSheet';
import FullScreen from '../../../../table/new/FullScreen';
import Refresh from '../../../../table/new/Refresh';
import ResultsCount from '../../../../table/new/ResultsCount';
import Search from '../../../../table/new/SearchForTable';

const Advertisers = () => {
  const store = useStore();
  const [prevTimeConfig, setPrevTimeConfig] = useState(null);
  const [editItemId, setEditItemId] = useState(null);

  return (
    <PageWrapper
      firstTimeConfig='7day'
      prevTimeConfig={prevTimeConfig}
      breadcrumbs={[
        {title: 'Партнеры'},
        {isSeparator: true},
        {title: 'Рекламодатели', path: '/advertisers/list', isActive: true},
      ]}
      title={'Рекламодатели'}
    >
      <TableWrapper
        setPrevTimeConfig={setPrevTimeConfig}
        prevTimeConfig={prevTimeConfig}
        getMethod={'Advertisers/getAdvertisersTable'}
        getFilters={getFilters}
        setEditItemId={setEditItemId}
        edit={'/advertisers/list/'}
        defaultFilters={[
          {filter: 'advertiser_id', isFixed: true, options: []},
          {filter: 'offer_id', isFixed: true, options: []},
          {filter: 'type', isFixed: true, options: []},
          {filter: 'state', isFixed: true, options: ['recently_created', 'with_data']},
        ]}
        defaultGroups={[
          {group: 'advertiser', isFixed: true},
          {group: 'offer', isFixed: false},
          {group: 'landing', isFixed: false},
        ]}
        //на випадок якщо нам взагалі не потрібно показувати вибір груп
        hasHiddenGroups={false}
        baseFields={baseFields.filter((item) => item.value !== 'clicks')}
        disabledByDefault={[
          'lead2appeal',
          'lead2fd',
          'chat2reg',
          'chat2fd',
          'chat2cpa',
          'reg2fd',
          'fd2cpa',
          'reg2rs',
          'chat2rs',
          'lead2rs',
          'click2rs',
        ]}
      >
        <Filters
          facebookStatisticsFilters={facebookStatisticsFilters}
          facebookStatisticsGroups={facebookStatisticsGroups}
          childrenNearGroups={
            <>
              {!(store.roles.includes(13) || store.roles.includes(32)) && (
                <Link to={'/advertisers/add'}>
                  <Button>
                    <>
                      <i className='ki-duotone ki-plus fs-2'></i>Создать
                    </>
                  </Button>
                </Link>
              )}
              <Search />
            </>
          }
          childrenPresets={
            <>
              <ResultsCount />
              <BlankSheet />
              <Columns />
              <Presets />
              <FullScreen />
            </>
          }
          childrenHead={false}
          childrenRefresh={false}
          childrenByFilters={<Refresh />}
        />
      </TableWrapper>
    </PageWrapper>
  );
};

export default observer(Advertisers);
